import { render, staticRenderFns } from "./InstantCreditFormStepNotes.vue?vue&type=template&id=15272df5"
import script from "./InstantCreditFormStepNotes.vue?vue&type=script&lang=js"
export * from "./InstantCreditFormStepNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports